import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import Chart from "chart.js";
import {Utilities} from "../../../utils/utilities";
import {TranslateService} from "@ngx-translate/core";
import {ChartConfig} from "../../../utils/chartConfig";
import {LineOrBarChartData} from "../../../models/charts/LineOrBarChartData";

@Component({
  selector: 'app-line-or-bar-chart-with-tabs',
  templateUrl: './line-or-bar-chart-with-tabs.component.html',
  styleUrls: ['./line-or-bar-chart-with-tabs.component.scss']
})
export class LineOrBarChartWithTabsComponent implements OnChanges{
  @Input() chartData:LineOrBarChartData;
  @Input() currency:any;
  public canvas: any;
  public ctx: any;
  public chart:Chart;

  public currentIndex:number = 0;

  constructor(private translateService: TranslateService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.chartData.firstChange) {
      this.canvas = document.getElementById(this.chartData.canvasElementId +'_' + this.currency.code).getElementsByTagName("canvas")[0];
      this.ctx = this.canvas.getContext("2d");
    }
    let gradientStroke = this.ctx.createLinearGradient(0, 230, 0, 50);

    let config = ChartConfig.getLineOrBarConfig(
        this.chartData.chartType,
        this.chartData.chartLabels,
        gradientStroke,
        this.chartData.color,
        ChartConfig.GradientChartOptions.gradientChartOptionsConfigurationWithTooltipRed
    );
    this.chart = new Chart(this.ctx, config);

    this.tabClicked(0)
  }

  tabClicked(index:number){
    this.currentIndex = index;
    let newData = this.chartData.dataSets[this.currentIndex];
    // új adat beállítása
    this.chart.data.datasets[0].data = newData;
    // tooltip label beállítása
    this.translateService.get(this.chartData.tabs[this.currentIndex].label).subscribe((text:string) => {
      this.chart.data.datasets[0].label = text;
    });
    // y tengely min max értékének beállítása
    this.chart.options.scales.yAxes[0].ticks.suggestedMin = Utilities.findMin(newData);
    this.chart.options.scales.yAxes[0].ticks.suggestedMax = Utilities.findMax(newData);
    // chart frissítése
    this.chart.update()
  }

  hasIcon():boolean{
    return this.chartData.tabs[this.currentIndex].icon != undefined;
  }

  getIconClasses():string{
    if(this.hasIcon()) return this.chartData.tabs[this.currentIndex].icon;
    return "";
  }

  tabActive(tabIndex:number):boolean{
    return tabIndex == this.currentIndex;
  }

}
